import { FormControl, FormErrorMessage, FormLabel, Text, VStack } from "@chakra-ui/react";
import { Select, chakraComponents, OptionProps } from "chakra-react-select";
import { selectChakraStyles } from "utils/constants";
import { useEffect, useState } from "react";
import { SelectOption } from "utils/types";
import { useLoansQuery } from "modules/loan/queries/use-loans-query";

const customComponents = {
  Option: ({ children, ...props }: OptionProps) => {
    const data: {
      label: string;
      borrower_company: string;
    } = props.data as any;
    return (
      <chakraComponents.Option {...props}>
        <VStack alignItems="flex-start" spacing="0px">
          <Text display="block">{data.label}</Text>
          <Text fontSize="13px">{data.borrower_company}</Text>
        </VStack>
      </chakraComponents.Option>
    );
  },
};

const LoansField = ({
  loan,
  setLoan,
  isMulti,
  isRequired = false,
}: {
  loan: SelectOption | null;
  setLoan: (payload: SelectOption | null) => void;
  isMulti?: boolean;
  isRequired?: boolean;
}) => {
  const [loanOptions, setLoanOptions] = useState<SelectOption[]>([]);
  const { data: loans } = useLoansQuery();

  useEffect(() => {
    if (loans) {
      const formattedOptions = loans.map((record: any) => ({
        label: record.name,
        value: record.id as string,
        borrower_company: record.borrower_company.name,
      }));
      setLoanOptions(formattedOptions);
    }
  }, [loans]);

  return (
    <>
      <FormControl mb="24px" isRequired={isRequired} isInvalid={isRequired && !loan}>
        <FormLabel>Select Loan</FormLabel>
        <FormErrorMessage>Please select a loan</FormErrorMessage>
        <Select
          isMulti={isMulti}
          useBasicStyles
          noOptionsMessage={() => "No loans found."}
          selectedOptionColor="black"
          colorScheme="purple"
          variant="outline"
          chakraStyles={selectChakraStyles}
          value={loan}
          onChange={(newValue: SelectOption | unknown) => setLoan(newValue as SelectOption | null)}
          options={loanOptions}
          components={customComponents}
        />
      </FormControl>
    </>
  );
};

export default LoansField;
